module.exports.GLOBAL_API_DOMAIN = '/wlxy/';


// WEBPACK FOOTER //
// ./src/config/index.js